var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { t } from 'i18next';
import { Howl } from 'howler';
import { FRACTION_CONFIG } from '../constants/fractionConfig';
import { TILE_COLORS } from '../widgets/ColoredTiles';
var html5Audio = new Audio();
html5Audio.preload = 'metadata'; // Load only metadata, not full audio file
var htmlAudioObjects = {};
var audioOnStatus = true;
var playerAudObj = null;
var howlAudObj = {};
var playingRef = [];
export var toggleAudio = function (_bool) {
    audioOnStatus = _bool;
};
export var setAudioConfig = function (jsonObj) {
    playerAudObj = jsonObj;
    for (var i in playerAudObj) {
        if (i === 'bg_music') {
            html5Audio.src = playerAudObj['bg_music'];
            html5Audio.loop = true;
            html5Audio.volume = 1;
            html5Audio.pause();
        }
        else if (i.includes('questionAudio')) {
            htmlAudioObjects[i] = new Audio();
            htmlAudioObjects[i].preload = 'metadata'; // Load only metadata, not full audio file
            htmlAudioObjects[i].src = playerAudObj[i];
            htmlAudioObjects[i].loop = false;
            htmlAudioObjects[i].volume = 1;
        }
        else {
            //console.log(i);
            howlAudObj[i] = new Howl({
                src: playerAudObj[i],
                loop: false,
                volume: i.indexOf('aud') !== -1 ? 1 : 0.25,
            });
        }
    }
};
export var playHowlAudio = function (obj) {
    var _b, _c;
    //console.log("playHowlAudio", obj.id);
    if (obj.id === 'bg_music') {
        html5Audio.play();
    }
    else if (obj.id.includes('questionAudio')) {
        htmlAudioObjects[obj.id].play();
    }
    else if (obj.id && audioOnStatus) {
        (_b = howlAudObj[obj.id]) === null || _b === void 0 ? void 0 : _b.play();
        playingRef.push(obj.id);
    }
    if (obj.onEnded) {
        htmlAudioObjects[obj.id] && (htmlAudioObjects[obj.id].onended = function () { return obj.onEnded(); });
        (_c = howlAudObj[obj.id]) === null || _c === void 0 ? void 0 : _c.off('end').on('end', function () {
            var index = playingRef.indexOf(obj.id);
            if (index > -1) {
                // only splice array when item is found
                playingRef.splice(index, 1); // 2nd parameter means remove one item only
            }
            obj.onEnded();
        });
    }
};
// Global modifier key tracking — works even when event objects lack modifier flags
// (e.g. Raphael SVG click events).
var _modifierKeys = { shift: false, ctrl: false, meta: false };
// Used by focus handlers that need to know whether the user is in the middle
// of a multi-select gesture, since a `focus` event doesn't carry modifier
// state. Returns true when shift / ctrl / meta is held right now.
export var isMultiSelectModifierHeld = function () {
    return _modifierKeys.shift || _modifierKeys.ctrl || _modifierKeys.meta;
};
if (typeof window !== 'undefined') {
    window.addEventListener('keydown', function (e) {
        if (e.key === 'Shift')
            _modifierKeys.shift = true;
        if (e.key === 'Control')
            _modifierKeys.ctrl = true;
        if (e.key === 'Meta')
            _modifierKeys.meta = true;
    }, true);
    window.addEventListener('keyup', function (e) {
        if (e.key === 'Shift')
            _modifierKeys.shift = false;
        if (e.key === 'Control')
            _modifierKeys.ctrl = false;
        if (e.key === 'Meta')
            _modifierKeys.meta = false;
    }, true);
    // Reset on blur (user switches tabs while holding key)
    window.addEventListener('blur', function () {
        _modifierKeys.shift = false;
        _modifierKeys.ctrl = false;
        _modifierKeys.meta = false;
    });
}
export var selectTool = function (e, id, selectedTool, allowRemove) {
    if (allowRemove === void 0) { allowRemove = true; }
    var _a = [];
    var _multiSelect = e.ctrlKey || e.metaKey || e.shiftKey ||
        _modifierKeys.shift || _modifierKeys.ctrl || _modifierKeys.meta;
    var result;
    if (_multiSelect) {
        if (selectedTool.includes(id) && allowRemove) {
            result = selectedTool.filter(function (_val) { return _val !== id; });
        }
        else if (!selectedTool.includes(id)) {
            result = __spreadArray(__spreadArray([], selectedTool, true), [id], false);
        }
        else {
            result = selectedTool;
        }
    }
    else if (selectedTool.includes(id) && allowRemove) {
        result = [];
    }
    else if (!selectedTool.includes(id)) {
        result = [id];
    }
    else {
        result = selectedTool;
    }
    var _resultUnique = new Set(result);
    if (_resultUnique.size !== result.length) {
        console.log('[MultiDrag] DUPLICATE IDS from selectTool()', JSON.stringify({
            rawLength: result.length,
            uniqueLength: _resultUnique.size,
            result: result,
        }));
    }
    return result;
};
/**
 * Bring-to-front via array order: moves the given ids to the end of the
 * manipulative array, in the order they're listed in `idsInOrder`, leaving
 * every other item in its original relative order. Since WhiteBoard renders
 * manipulatives by iterating this array, later position = drawn on top —
 * no separate numeric zIndex field needed.
 */
export var bringManipulativesToFront = function (manipulative, idsInOrder) {
    var promoteSet = new Set(idsInOrder);
    var rest = manipulative.filter(function (m) { var _b; return !promoteSet.has((_b = m.data.id) !== null && _b !== void 0 ? _b : ''); });
    var byId = new Map(manipulative.map(function (m) { return [m.data.id, m]; }));
    var promoted = idsInOrder.map(function (id) { return byId.get(id); }).filter(function (m) { return !!m; });
    return __spreadArray(__spreadArray([], rest, true), promoted, true);
};
/**
 * Enforces the linking-cubes chain stacking invariant: within a chain, array
 * position must ascend with `chainIndex` (lowest chainIndex = backmost,
 * highest chainIndex = frontmost), matching each chain's spatial convention
 * (vertical: chainIndex 0 = visual bottom; horizontal: chainIndex 0 =
 * leftmost). Reuses `bringManipulativesToFront` by feeding it the chain's
 * member ids pre-sorted ascending by chainIndex.
 */
export var reorderChainByIndex = function (manipulative, chainId) {
    var chainMembers = manipulative.filter(function (m) { return m.data.type === 'linkingCubes' && m.data.chainId === chainId; });
    if (chainMembers.length === 0)
        return manipulative;
    var sortedIds = __spreadArray([], chainMembers, true).sort(function (a, b) {
        var _b, _c;
        return ((_b = a.data.chainIndex) !== null && _b !== void 0 ? _b : 0) -
            ((_c = b.data.chainIndex) !== null && _c !== void 0 ? _c : 0);
    })
        .map(function (m) { var _b; return (_b = m.data.id) !== null && _b !== void 0 ? _b : ''; });
    return bringManipulativesToFront(manipulative, sortedIds);
};
/**
 * Ray-casting point-in-polygon test.
 * Returns true when (px, py) lies inside the given polygon.
 */
export var isPointInPolygon = function (px, py, polygon) {
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        var xi = polygon[i].x, yi = polygon[i].y;
        var xj = polygon[j].x, yj = polygon[j].y;
        var intersect = yi > py !== yj > py && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
        if (intersect)
            inside = !inside;
    }
    return inside;
};
export function fetchData(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data]; // Return the parsed JSON data
                case 3:
                    error_1 = _b.sent();
                    console.error('Fetch error:', error_1);
                    return [2 /*return*/, null]; // or handle error appropriately
                case 4: return [2 /*return*/];
            }
        });
    });
}
export var toCamelCase = function (str) {
    return str.toLowerCase().replace(/[-_ ]+([a-z])/g, function (_, c) { return c.toUpperCase(); });
};
/**
 * Calculates rotated bounding box with padding.
 *
 * @param x - top-left X
 * @param y - top-left Y
 * @param width
 * @param height
 * @param rotation - degrees
 * @param padding
 */
export var calculateBoxWithPaddingAndRotation = function (x, y, width, height, rotation, padding, isCenter) {
    if (rotation === void 0) { rotation = 0; }
    if (padding === void 0) { padding = 0; }
    if (isCenter === void 0) { isCenter = false; }
    var rad = (rotation * Math.PI) / 180;
    if (isCenter) {
        x = x - width / 2;
        y = y - height / 2;
    }
    var cx = x + width / 2;
    var cy = y + height / 2;
    // Helper to rotate any point around center
    var rotate = function (px, py) {
        var dx = px - cx;
        var dy = py - cy;
        return {
            x: cx + dx * Math.cos(rad) - dy * Math.sin(rad),
            y: cy + dx * Math.sin(rad) + dy * Math.cos(rad),
        };
    };
    // original corners
    var p1 = rotate(x, y); // top-left
    var p2 = rotate(x + width, y); // top-right
    var p3 = rotate(x, y + height); // bottom-left
    var p4 = rotate(x + width, y + height); // bottom-right
    // get bounding box
    var minX = Math.min(p1.x, p2.x, p3.x, p4.x);
    var maxX = Math.max(p1.x, p2.x, p3.x, p4.x);
    var minY = Math.min(p1.y, p2.y, p3.y, p4.y);
    var maxY = Math.max(p1.y, p2.y, p3.y, p4.y);
    // apply padding
    minX -= padding;
    minY -= padding;
    maxX += padding;
    maxY += padding;
    return {
        corners: { p1: p1, p2: p2, p3: p3, p4: p4 },
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY,
        width: maxX - minX,
        height: maxY - minY,
        centerX: (minX + maxX) / 2,
        centerY: (minY + maxY) / 2,
    };
};
export var toNumber = function (v) { return Math.floor(Number(v)) || 0; };
export var getMinMax = function (pt1, pt2) {
    return {
        minX: Math.min((pt1 === null || pt1 === void 0 ? void 0 : pt1.x) || 0, (pt2 === null || pt2 === void 0 ? void 0 : pt2.x) || 0),
        maxX: Math.max((pt1 === null || pt1 === void 0 ? void 0 : pt1.x) || 0, (pt2 === null || pt2 === void 0 ? void 0 : pt2.x) || 0),
        minY: Math.min((pt1 === null || pt1 === void 0 ? void 0 : pt1.y) || 0, (pt2 === null || pt2 === void 0 ? void 0 : pt2.y) || 0),
        maxY: Math.max((pt1 === null || pt1 === void 0 ? void 0 : pt1.y) || 0, (pt2 === null || pt2 === void 0 ? void 0 : pt2.y) || 0),
    };
};
/**
 * Debounce function that delays the execution of a function until after a specified delay.
 * @param func - The function to debounce
 * @param delay - The delay in milliseconds
 * @returns A debounced version of the function
 */
export var debounce = function (func, delay) {
    var timeoutId = null;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(function () {
            func.apply(void 0, args);
        }, delay);
    };
};
export var toFixed0 = function (value) {
    return Number(value.toFixed(0));
};
/**
 * Computes the combined lock state (positioning/editing) for the current selection.
 * Returns an object: { positioning: boolean, editing: boolean }
 */
export var getContentLockArray = function (_b) {
    var selectedTool = _b.selectedTool, text = _b.text, table = _b.table, annotations = _b.annotations, manipulative = _b.manipulative, _c = _b.shades, shades = _c === void 0 ? [] : _c;
    var positioningOR = false;
    var editingOR = false;
    selectedTool.forEach(function (toolId) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var lock = { positioning: false, editing: false };
        if (toolId.startsWith('text_')) {
            var index = Number(toolId.split('_')[1]);
            var item = text[index];
            if (item) {
                lock.positioning = ((_b = item.data.lock) === null || _b === void 0 ? void 0 : _b.positioning) || false;
                lock.editing = ((_c = item.data.lock) === null || _c === void 0 ? void 0 : _c.editing) || false;
            }
        }
        if (toolId.startsWith('annotations_')) {
            var index = Number(toolId.split('_')[1]);
            var item = annotations[index];
            if (item) {
                lock.positioning = ((_d = item.data.lock) === null || _d === void 0 ? void 0 : _d.positioning) || false;
                lock.editing = ((_e = item.data.lock) === null || _e === void 0 ? void 0 : _e.editing) || false;
            }
        }
        if (toolId.startsWith('shades_')) {
            var shadeSplit = toolId.split('_');
            var index = Number(shadeSplit[shadeSplit.length - 1]);
            var item = shades[index];
            if (item) {
                lock.positioning = ((_f = item.data.lock) === null || _f === void 0 ? void 0 : _f.positioning) || false;
                lock.editing = ((_g = item.data.lock) === null || _g === void 0 ? void 0 : _g.editing) || false;
            }
        }
        if (toolId.startsWith('tableText_')) {
            var parts = toolId.split('_');
            var tableIndex = Number(parts[1]);
            var tableItem = table[tableIndex];
            if (tableItem) {
                lock.positioning = ((_h = tableItem.data.lock) === null || _h === void 0 ? void 0 : _h.positioning) || false;
                if (parts.length >= 4) {
                    // Cell-level selection
                    var rowIndex = Number(parts[2]);
                    var colIndex = Number(parts[3]);
                    var cols = tableItem.data.colWidth.length;
                    var cellIndex = rowIndex * cols + colIndex;
                    var cell = tableItem.data.cellData[cellIndex];
                    if (cell) {
                        lock.editing = ((_j = cell.data.lock) === null || _j === void 0 ? void 0 : _j.editing) || false;
                    }
                }
                else {
                    // Table-level selection: locked if all cells are locked
                    lock.editing = ((_k = tableItem.data.cellData) === null || _k === void 0 ? void 0 : _k.length) > 0 &&
                        tableItem.data.cellData.every(function (c) { var _b, _c; return ((_c = (_b = c === null || c === void 0 ? void 0 : c.data) === null || _b === void 0 ? void 0 : _b.lock) === null || _c === void 0 ? void 0 : _c.editing) === true; });
                }
            }
        }
        if (toolId.startsWith('numberChart') ||
            toolId.startsWith('linkingCube') ||
            toolId.startsWith('spinner') ||
            toolId.startsWith('dice_') ||
            toolId.startsWith('deck_') ||
            toolId.startsWith('analog') ||
            toolId.startsWith('timer') ||
            toolId.startsWith('numberRacks') ||
            toolId.startsWith('arrayModel') ||
            toolId.startsWith('protractor') ||
            toolId.startsWith('fractionTiles_') ||
            toolId.startsWith('numberLine') ||
            toolId.startsWith('tableText') ||
            toolId.startsWith('patternShapes_') ||
            toolId.startsWith('numberPiece') ||
            toolId.startsWith('moneyPiece') ||
            toolId.startsWith('coloredTiles') ||
            toolId.startsWith('linearPiece_') ||
            toolId.startsWith('coinsAndCounters_')) {
            var item = manipulative.find(function (m) {
                var _b;
                return m.data.id === toolId ||
                    (m.data.type === 'fractionTiles' && toolId.startsWith((_b = m.data.id) !== null && _b !== void 0 ? _b : ''));
            });
            if (item) {
                lock.positioning = ((_l = item.data.lock) === null || _l === void 0 ? void 0 : _l.positioning) || false;
                lock.editing = ((_m = item.data.lock) === null || _m === void 0 ? void 0 : _m.editing) || false;
            }
        }
        if (toolId.startsWith('jumpBar') || toolId.startsWith('customTick')) {
            var item = manipulative.find(function (m) { return m.data.id === toolId; });
            if (item) {
                lock.positioning = ((_o = item.data.lock) === null || _o === void 0 ? void 0 : _o.positioning) || false;
                lock.editing = ((_p = item.data.lock) === null || _p === void 0 ? void 0 : _p.editing) || false;
            }
        }
        if (toolId.startsWith('card_')) {
            var parentDeck = manipulative.find(function (m) {
                var _b;
                return m.data.type === 'deck' &&
                    'cards' in m.data &&
                    ((_b = m.data.cards) === null || _b === void 0 ? void 0 : _b.some(function (card) { return card.id === toolId; }));
            });
            if (parentDeck && 'cards' in parentDeck.data) {
                var card = parentDeck.data.cards.find(function (c) { return c.id === toolId; });
                lock.positioning = (_r = (_q = card === null || card === void 0 ? void 0 : card.lock) === null || _q === void 0 ? void 0 : _q.positioning) !== null && _r !== void 0 ? _r : false;
                lock.editing = (_t = (_s = card === null || card === void 0 ? void 0 : card.lock) === null || _s === void 0 ? void 0 : _s.editing) !== null && _t !== void 0 ? _t : false;
            }
        }
        if (toolId.startsWith('numberFrame_')) {
            var item = manipulative.find(function (m) { return m.data.id === toolId; });
            if (item) {
                lock.positioning = ((_u = item.data.lock) === null || _u === void 0 ? void 0 : _u.positioning) || false;
                lock.editing = ((_v = item.data.lock) === null || _v === void 0 ? void 0 : _v.editing) || false;
            }
        }
        if (toolId.startsWith('counter_') || toolId.startsWith('numberFrameCounter_')) {
            var item = manipulative.find(function (m) { return m.data.id === toolId; });
            if (item) {
                lock.positioning = ((_w = item.data.lock) === null || _w === void 0 ? void 0 : _w.positioning) || false;
                lock.editing = ((_x = item.data.lock) === null || _x === void 0 ? void 0 : _x.editing) || false;
            }
        }
        if (toolId.startsWith('manipulativeGroup_')) {
            var item = manipulative.find(function (m) { return m.data.groupId === toolId; });
            if (item) {
                lock.positioning = ((_y = item.data.lock) === null || _y === void 0 ? void 0 : _y.positioning) || false;
                lock.editing = ((_z = item.data.lock) === null || _z === void 0 ? void 0 : _z.editing) || false;
            }
        }
        positioningOR = positioningOR || lock.positioning;
        editingOR = editingOR || lock.editing;
    });
    return { positioning: positioningOR, editing: editingOR };
};
export var pointFromCenterAndAngle = function (centerX, centerY, angleDeg, distance) {
    var angleRad = (angleDeg * Math.PI) / 180;
    return {
        x: centerX + Math.cos(angleRad) * distance,
        y: centerY + Math.sin(angleRad) * distance,
    };
};
export var distanceBetweenTwoPoints = function (p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
};
export var parseFraction = function (value) {
    if (value) {
        var parts = value.split('-');
        if (parts.length === 2) {
            return { numerator: Number(parts[1]), denominator: 0 };
        }
        if (parts.length === 3) {
            return { numerator: Number(parts[1]), denominator: Number(parts[2]) };
        }
    }
    return null;
};
/**
 * Returns a natural-language string for a fraction suitable for screen readers.
 * e.g. (1,2) → "half", (1,4) → "one fourth", (3,4) → "3 fourths"
 * Pass shapeType to get "half of rectangle" style phrasing via fractionOfShape key.
 */
export var getFractionAriaText = function (numerator, denominator, shapeType) {
    var ordinals = {
        2: { singular: t('text.fractionHalf', { defaultValue: 'half' }), plural: t('text.fractionHalves', { defaultValue: 'halves' }) },
        3: { singular: t('text.fractionThird', { defaultValue: 'third' }), plural: t('text.fractionThirds', { defaultValue: 'thirds' }) },
        4: { singular: t('text.fractionFourth', { defaultValue: 'fourth' }), plural: t('text.fractionFourths', { defaultValue: 'fourths' }) },
        5: { singular: t('text.fractionFifth', { defaultValue: 'fifth' }), plural: t('text.fractionFifths', { defaultValue: 'fifths' }) },
        6: { singular: t('text.fractionSixth', { defaultValue: 'sixth' }), plural: t('text.fractionSixths', { defaultValue: 'sixths' }) },
        8: { singular: t('text.fractionEighth', { defaultValue: 'eighth' }), plural: t('text.fractionEighths', { defaultValue: 'eighths' }) },
        10: { singular: t('text.fractionTenth', { defaultValue: 'tenth' }), plural: t('text.fractionTenths', { defaultValue: 'tenths' }) },
        12: { singular: t('text.fractionTwelfth', { defaultValue: 'twelfth' }), plural: t('text.fractionTwelfths', { defaultValue: 'twelfths' }) },
    };
    var fraction;
    if (denominator === 0 || denominator === 1 || numerator === denominator) {
        fraction = t('text.fractionWhole', { defaultValue: 'whole' });
    }
    else {
        var ordinal = ordinals[denominator];
        if (!ordinal) {
            fraction = "".concat(numerator, "/").concat(denominator);
        }
        else if (numerator === 1 && denominator === 2) {
            fraction = ordinal.singular; // "half"
        }
        else if (numerator === 1) {
            fraction = "".concat(t('text.one', { defaultValue: 'one' }), " ").concat(ordinal.singular);
        }
        else {
            fraction = "".concat(numerator, " ").concat(ordinal.plural);
        }
    }
    if (shapeType) {
        return t('text.fractionOfShape', {
            fraction: fraction,
            shape: t("text.".concat(shapeType), { defaultValue: shapeType }),
            defaultValue: '{{fraction}} of {{shape}}',
        });
    }
    return fraction;
};
export var gcd = function (a, b) {
    var _b;
    a = Math.abs(a);
    b = Math.abs(b);
    while (b) {
        _b = [b, a % b], a = _b[0], b = _b[1];
    }
    return a;
};
export var sumAndReduceFractions = function (fractions) {
    var num = 0;
    var den = 1;
    for (var _i = 0, fractions_1 = fractions; _i < fractions_1.length; _i++) {
        var fraction = fractions_1[_i];
        var parsed = parseFraction(fraction);
        if (!parsed) {
            throw new Error("Invalid fraction format: ".concat(fraction));
        }
        var n = parsed.numerator;
        var d = parsed.denominator;
        // Handle whole integers: denominator 0 means it's an integer value n (equivalent to n/1)
        if (d === 0) {
            d = 1;
        }
        if (!Number.isInteger(n) || !Number.isInteger(d) || d === 0) {
            throw new Error("Invalid fraction values: ".concat(fraction));
        }
        // Add fractions: num/den + n/d = (num*d + n*den) / (den*d), then reduce
        var g = gcd(den, d);
        // Divide before multiplying to avoid overflow if possible
        num = num * (d / g) + n * (den / g);
        den = (den / g) * d;
        var g2 = gcd(Math.abs(num), den);
        num /= g2;
        den /= g2;
    }
    return den === 1 ? "fraction-".concat(num) : "fraction-".concat(num, "-").concat(den);
};
export var getFractionDimensions = function (fractionSize) {
    var config = FRACTION_CONFIG[fractionSize];
    if (config)
        return config;
    var parsed = parseFraction(fractionSize);
    if (!parsed)
        return null;
    var numerator = parsed.numerator, denominator = parsed.denominator;
    var fractionValue = denominator === 0 ? numerator : numerator / denominator;
    // Standard full width is 660, standard sweep is 360
    var standardWidth = 660;
    var standardSweep = 360;
    return {
        id: fractionSize,
        numerator: numerator,
        denominator: denominator,
        rectangle: {
            width: standardWidth * fractionValue,
            height: 55,
        },
        circle: {
            start: denominator === 1 ? 0 : 90 - (standardSweep * fractionValue) / 2, // Center the sector at 12 o'clock visually for single pieces
            sweep: standardSweep * fractionValue,
        },
        button: {
            width: 120, // Default button size
            height: 50,
            circleSize: 120,
        },
    };
};
export var polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
};
export var describeArc = function (x, y, radius, startAngle, endAngle) {
    var start = polarToCartesian(x, y, radius, endAngle);
    var end = polarToCartesian(x, y, radius, startAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    var d = [
        'M',
        x,
        y,
        'L',
        start.x,
        start.y,
        'A',
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y,
        'Z',
    ].join(' ');
    return d;
};
export var getFractionCircleConfig = function (fraction, rotationOffset, customSweep) {
    var _b;
    if (rotationOffset === void 0) { rotationOffset = 0; }
    // If this tile has a custom sweep (glued tile), use it
    if (customSweep != null) {
        return { start: rotationOffset, sweep: customSweep };
    }
    // Angles: 0 is 3 o'clock, 90 is 6 o'clock, 180 is 9 o'clock, 270 is 12 o'clock
    // Apply rotationOffset to the start angle
    var baseStart = function (angle) { return (angle + rotationOffset) % 360; };
    var config = ((_b = getFractionDimensions(fraction)) === null || _b === void 0 ? void 0 : _b.circle) || { start: 0, sweep: 360 };
    return { start: baseStart(config.start), sweep: config.sweep };
};
export var getCircleBoundingBox = function (fractionSize, rotation, scale, customSweep, padding) {
    var _b;
    if (rotation === void 0) { rotation = 0; }
    if (padding === void 0) { padding = 5; }
    var startAngle;
    var sweep;
    if (customSweep != null) {
        startAngle = rotation % 360;
        sweep = customSweep;
    }
    else {
        var config = ((_b = getFractionDimensions(fractionSize)) === null || _b === void 0 ? void 0 : _b.circle) || { start: 0, sweep: 360 };
        startAngle = (config.start + rotation) % 360;
        sweep = config.sweep;
    }
    var cx = 150;
    var cy = 150;
    var r = 150;
    var points = [{ x: cx, y: cy }]; // Center
    var degToRad = function (deg) { return (deg * Math.PI) / 180; };
    // Start and End points
    points.push({
        x: cx + r * Math.cos(degToRad(startAngle)),
        y: cy + r * Math.sin(degToRad(startAngle)),
    });
    points.push({
        x: cx + r * Math.cos(degToRad(startAngle + sweep)),
        y: cy + r * Math.sin(degToRad(startAngle + sweep)),
    });
    // Check cardinals
    var startTotal = startAngle;
    var endTotal = startAngle + sweep;
    var firstCardinal = Math.ceil(startTotal / 90) * 90;
    var lastCardinal = Math.floor(endTotal / 90) * 90;
    for (var ang = firstCardinal; ang <= lastCardinal; ang += 90) {
        points.push({
            x: cx + r * Math.cos(degToRad(ang)),
            y: cy + r * Math.sin(degToRad(ang)),
        });
    }
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    points.forEach(function (p) {
        if (p.x < minX)
            minX = p.x;
        if (p.x > maxX)
            maxX = p.x;
        if (p.y < minY)
            minY = p.y;
        if (p.y > maxY)
            maxY = p.y;
    });
    // Apply padding (unscaled)
    var pad = padding;
    minX = Math.floor(minX - pad);
    minY = Math.floor(minY - pad);
    maxX = Math.ceil(maxX + pad);
    maxY = Math.ceil(maxY + pad);
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY,
    };
};
/**
 * Generates a CSS clip-path polygon string for the circular sector.
 */
export var getCircleClipPath = function (fractionSize, rotation, customSweep) {
    if (rotation === void 0) { rotation = 0; }
    var bb = getCircleBoundingBox(fractionSize, rotation, 1, customSweep, 5);
    var config = getFractionCircleConfig(fractionSize, rotation, customSweep);
    var start = config.start, sweep = config.sweep;
    if (sweep >= 360)
        return 'circle(50% at 50% 50%)';
    var cx = 150;
    var cy = 150;
    var r = 155; // 5px buffer for 3px stroke
    var toLocal = function (p) { return ({
        x: ((p.x - bb.x) / bb.width) * 100,
        y: ((p.y - bb.y) / bb.height) * 100,
    }); };
    var points = [];
    // Important: The tip of the sector (center of circle) has a 3px stroke.
    // We move the clip-path center point slightly "outward" (opposite to sector direction)
    // to ensure the tip's border is not cut.
    var midAngle = start + sweep / 2;
    var centerOffset = polarToCartesian(cx, cy, 5, midAngle + 180);
    points.push(toLocal(centerOffset));
    // Start point (slightly before the mathematical start to include stroke)
    points.push(toLocal(polarToCartesian(cx, cy, r, start - 2)));
    var step = 10;
    for (var a = 0; a <= sweep; a += step) {
        points.push(toLocal(polarToCartesian(cx, cy, r, start + a)));
    }
    // End points (slightly after the mathematical end)
    points.push(toLocal(polarToCartesian(cx, cy, r, start + sweep)));
    points.push(toLocal(polarToCartesian(cx, cy, r, start + sweep + 2)));
    return "polygon(".concat(points.map(function (p) { return "".concat(p.x.toFixed(2), "% ").concat(p.y.toFixed(2), "%"); }).join(', '), ")");
};
export var detectManualTileSnap = function (dragPos, dragSize, allManipulatives, excludeId, snapThreshold, cellSize, movingMode, draggedScale) {
    var _b, _c;
    if (snapThreshold === void 0) { snapThreshold = 40; }
    if (cellSize === void 0) { cellSize = 110; }
    if (draggedScale === void 0) { draggedScale = 1; }
    var snappedX = dragPos.x;
    var snappedY = dragPos.y;
    // E3: track per-axis nearest-target distance so a second target only overrides
    // the first if it is strictly closer.
    var bestDistY = Infinity;
    var bestDistX = Infinity;
    var dragLeft = dragPos.x;
    var dragTop = dragPos.y;
    var dragRight = dragPos.x + dragSize.width;
    var dragBottom = dragPos.y + dragSize.height;
    var _loop_1 = function (item) {
        if (item.data.type === 'coloredTiles' &&
            item.data.id !== excludeId &&
            !item.data.isInvisible) {
            var target_1 = item.data;
            // PREVENT INTERACTION FOR "OUTLINE" TILES (NO SNAP, NO MERGE)
            // Allow internal grid snapping even if merging is prevented
            var canMerge = !((movingMode === 'outline' && (target_1.generationMode === 'random' || target_1.generationMode === 'manual' || target_1.generationMode === 'outline')) ||
                (movingMode === 'random' && target_1.generationMode === 'outline') ||
                (movingMode === 'random' && target_1.generationMode === 'manual'));
            // Scale-aware bounds: target may be visually scaled via data.scale.
            // E5: floor at 0.01 so a corrupt/zero scale can't propagate Infinity / NaN.
            var targetScale = Math.max(0.01, (_b = target_1.scale) !== null && _b !== void 0 ? _b : 1);
            var targetCellSize = cellSize * targetScale;
            var targetWidth = target_1.columns * targetCellSize;
            var targetHeight = target_1.rows * targetCellSize;
            var targetLeft = target_1.center.x - targetWidth / 2;
            var targetTop = target_1.center.y - targetHeight / 2;
            var targetRight = targetLeft + targetWidth;
            var targetBottom = targetTop + targetHeight;
            // B5: snap "feel" tracks the smaller of the two tiles in the interaction.
            var effectiveThreshold = snapThreshold * Math.min(draggedScale, targetScale);
            var dragCenterX = dragLeft + dragSize.width / 2;
            var dragCenterY = dragTop + dragSize.height / 2;
            // ── CELL-AWARE BRANCH (manual mode, sparse partColors) ─────────────────
            // For manual tiles with filled cells, snap the ghost to the closest empty
            // neighbour of any filled cell. Runs *before* internal-grid-snap so a drop
            // near the bounding-box's outer edge — including drops that are just inside
            // the rectangle near a perimeter cell — can prefer extending the tile (EDGE
            // candidate at an out-of-bounds neighbour) over being "snapped into" an
            // interior empty cell. Mirrors the drop-time logic in findSnapTargetManualTile.
            var partColorsMap_1 = target_1.partColors;
            var isCellFilled = function (r, c) {
                if (r < 0 || r >= target_1.rows || c < 0 || c >= target_1.columns)
                    return false;
                var v = partColorsMap_1 === null || partColorsMap_1 === void 0 ? void 0 : partColorsMap_1["".concat(r, "-").concat(c)];
                return !!v && v !== 'transparent';
            };
            var hasFilledCells = !!partColorsMap_1 &&
                Object.values(partColorsMap_1).some(function (v) { return !!v && v !== 'transparent'; });
            var isSingleCellDrag = Math.abs(dragSize.width - targetCellSize) < 1 &&
                Math.abs(dragSize.height - targetCellSize) < 1;
            var isManualCellAware = target_1.generationMode === 'manual' && canMerge && hasFilledCells && isSingleCellDrag;
            if (isManualCellAware) {
                var sides = [
                    { dr: -1, dc: 0 },
                    { dr: 1, dc: 0 },
                    { dr: 0, dc: -1 },
                    { dr: 0, dc: 1 },
                ];
                var cellBestDist = Infinity;
                var cellBestX = snappedX;
                var cellBestY = snappedY;
                for (var r = 0; r < target_1.rows; r++) {
                    for (var c = 0; c < target_1.columns; c++) {
                        if (!isCellFilled(r, c))
                            continue;
                        for (var _h = 0, sides_1 = sides; _h < sides_1.length; _h++) {
                            var _j = sides_1[_h], dr = _j.dr, dc = _j.dc;
                            var nr = r + dr;
                            var nc = c + dc;
                            if (isCellFilled(nr, nc))
                                continue;
                            var cellCx = targetLeft + (nc + 0.5) * targetCellSize;
                            var cellCy = targetTop + (nr + 0.5) * targetCellSize;
                            var dx = Math.max(0, Math.abs(dragCenterX - cellCx) - targetCellSize / 2);
                            var dy = Math.max(0, Math.abs(dragCenterY - cellCy) - targetCellSize / 2);
                            var dist = Math.hypot(dx, dy);
                            if (dist > effectiveThreshold)
                                continue;
                            if (dist < cellBestDist) {
                                cellBestDist = dist;
                                cellBestX = cellCx - dragSize.width / 2;
                                cellBestY = cellCy - dragSize.height / 2;
                            }
                        }
                    }
                }
                // Found a closer empty-neighbour than anything else this loop has seen?
                // Short-circuit and return — mirrors internal-grid-snap's early return shape.
                if (cellBestDist < Infinity) {
                    return { value: { x: cellBestX, y: cellBestY } };
                }
            }
            // --- Internal Grid Snapping ---
            // Check if the center of the dragged block is inside the target tile.
            // Runs after cell-aware so an out-of-bounds-neighbour candidate (extension)
            // wins over "snap into the bounding rectangle" when both apply.
            if (dragCenterX >= targetLeft &&
                dragCenterX <= targetRight &&
                dragCenterY >= targetTop &&
                dragCenterY <= targetBottom) {
                // Snap to the internal 1x1 grid (using scaled cell size)
                var relativeX = dragLeft - targetLeft;
                var relativeY = dragTop - targetTop;
                var snappedRelX = Math.round(relativeX / targetCellSize) * targetCellSize;
                var snappedRelY = Math.round(relativeY / targetCellSize) * targetCellSize;
                // B8: clamp by the dragged tile's full extent so a multi-cell drop can't
                // overflow the target's right/bottom edge.
                var maxRelX = Math.max(0, targetWidth - dragSize.width);
                var maxRelY = Math.max(0, targetHeight - dragSize.height);
                return { value: {
                        x: targetLeft + Math.max(0, Math.min(maxRelX, snappedRelX)),
                        y: targetTop + Math.max(0, Math.min(maxRelY, snappedRelY)),
                    } };
            }
            // --------------------------------------
            // Vertical snapping (snap to top/bottom edges or align horizontally)
            if (canMerge && target_1.generationMode !== 'outline') {
                var isWithinHorizontalRange = dragRight >= targetLeft - effectiveThreshold && dragLeft <= targetRight + effectiveThreshold;
                if (isWithinHorizontalRange) {
                    // Pick the closest of the four Y-edges for THIS target, then keep it
                    // only if it beats the prior best across all targets.
                    var candY = snappedY;
                    var candDist = Infinity;
                    var dY1 = Math.abs(dragBottom - targetTop);
                    if (dY1 < effectiveThreshold && dY1 < candDist) {
                        candY = targetTop - dragSize.height;
                        candDist = dY1;
                    }
                    var dY2 = Math.abs(dragTop - targetBottom);
                    if (dY2 < effectiveThreshold && dY2 < candDist) {
                        candY = targetBottom;
                        candDist = dY2;
                    }
                    var dY3 = Math.abs(dragTop - targetTop);
                    if (dY3 < effectiveThreshold && dY3 < candDist) {
                        candY = targetTop;
                        candDist = dY3;
                    }
                    var dY4 = Math.abs(dragBottom - targetBottom);
                    if (dY4 < effectiveThreshold && dY4 < candDist) {
                        candY = targetBottom - dragSize.height;
                        candDist = dY4;
                    }
                    if (candDist < bestDistY) {
                        snappedY = candY;
                        bestDistY = candDist;
                    }
                }
                // Horizontal snapping (snap to left/right edges or align vertically)
                var isWithinVerticalRange = dragBottom >= targetTop - effectiveThreshold && dragTop <= targetBottom + effectiveThreshold;
                if (isWithinVerticalRange) {
                    var candX = snappedX;
                    var candDist = Infinity;
                    var dX1 = Math.abs(dragRight - targetLeft);
                    if (dX1 < effectiveThreshold && dX1 < candDist) {
                        candX = targetLeft - dragSize.width;
                        candDist = dX1;
                    }
                    var dX2 = Math.abs(dragLeft - targetRight);
                    if (dX2 < effectiveThreshold && dX2 < candDist) {
                        candX = targetRight;
                        candDist = dX2;
                    }
                    var dX3 = Math.abs(dragLeft - targetLeft);
                    if (dX3 < effectiveThreshold && dX3 < candDist) {
                        candX = targetLeft;
                        candDist = dX3;
                    }
                    var dX4 = Math.abs(dragRight - targetRight);
                    if (dX4 < effectiveThreshold && dX4 < candDist) {
                        candX = targetRight - dragSize.width;
                        candDist = dX4;
                    }
                    if (candDist < bestDistX) {
                        snappedX = candX;
                        bestDistX = candDist;
                    }
                }
            }
        }
    };
    for (var _i = 0, allManipulatives_1 = allManipulatives; _i < allManipulatives_1.length; _i++) {
        var item = allManipulatives_1[_i];
        var state_1 = _loop_1(item);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    var horizontalEdges = []; // y-values: target tops and bottoms
    var verticalEdges = []; // x-values: target lefts and rights
    for (var _d = 0, allManipulatives_2 = allManipulatives; _d < allManipulatives_2.length; _d++) {
        var item = allManipulatives_2[_d];
        if (item.data.type !== 'coloredTiles' || item.data.id === excludeId)
            continue;
        if (item.data.isInvisible)
            continue;
        var target = item.data;
        if (target.generationMode === 'outline')
            continue;
        // E5: same scale floor as the main loop.
        var targetScale = Math.max(0.01, (_c = target.scale) !== null && _c !== void 0 ? _c : 1);
        var targetCellSize = cellSize * targetScale;
        var tw = target.columns * targetCellSize;
        var th = target.rows * targetCellSize;
        var tl = target.center.x - tw / 2;
        var tt = target.center.y - th / 2;
        horizontalEdges.push({ value: tt, targetId: target.id });
        horizontalEdges.push({ value: tt + th, targetId: target.id });
        verticalEdges.push({ value: tl, targetId: target.id });
        verticalEdges.push({ value: tl + tw, targetId: target.id });
    }
    // Use a threshold of 1 cell (110px) so users can drop within ~1 cell of a corner.
    var cornerThreshold = Math.max(snapThreshold, cellSize);
    var bestCornerX = snappedX;
    var bestCornerY = snappedY;
    var bestCornerDist = Infinity;
    for (var _e = 0, horizontalEdges_1 = horizontalEdges; _e < horizontalEdges_1.length; _e++) {
        var h = horizontalEdges_1[_e];
        for (var _f = 0, verticalEdges_1 = verticalEdges; _f < verticalEdges_1.length; _f++) {
            var v = verticalEdges_1[_f];
            // Must be from DIFFERENT tiles to form a true corner.
            if (h.targetId === v.targetId)
                continue;
            // 4 candidate corner positions (drag's TL aligned to corner in 4 quadrants).
            var candidates = [
                { x: v.value, y: h.value }, // drag below+right of corner
                { x: v.value - dragSize.width, y: h.value }, // drag below+left
                { x: v.value, y: h.value - dragSize.height }, // drag above+right
                { x: v.value - dragSize.width, y: h.value - dragSize.height }, // drag above+left
            ];
            for (var _g = 0, candidates_1 = candidates; _g < candidates_1.length; _g++) {
                var c = candidates_1[_g];
                var dist = Math.hypot(c.x - dragPos.x, c.y - dragPos.y);
                if (dist < cornerThreshold && dist < bestCornerDist) {
                    bestCornerDist = dist;
                    bestCornerX = c.x;
                    bestCornerY = c.y;
                }
            }
        }
    }
    // E4: only let corner snap override edge snap when the corner is actually
    // closer (in 2D distance) than the edge result. Otherwise the edge snap
    // wins because it's a tighter, more deliberate alignment.
    var edgeDist = Math.hypot(snappedX - dragPos.x, snappedY - dragPos.y);
    if (bestCornerDist < cornerThreshold && bestCornerDist < edgeDist) {
        snappedX = bestCornerX;
        snappedY = bestCornerY;
    }
    return { x: snappedX, y: snappedY };
};
/**
 * Finds a manual colored tile that is adjacent to the given bounding box.
 */
export var findSnapTargetManualTile = function (dragPos, dragSize, allManipulatives, excludeId, snapThreshold, cellSize, movingMode, draggedScale) {
    var _b;
    if (snapThreshold === void 0) { snapThreshold = 40; }
    if (cellSize === void 0) { cellSize = 110; }
    if (draggedScale === void 0) { draggedScale = 1; }
    var dragLeft = dragPos.x;
    var dragTop = dragPos.y;
    var dragRight = dragPos.x + dragSize.width;
    var dragBottom = dragPos.y + dragSize.height;
    // E3: walk every target, keep the closest edge match across all of them
    // (and the closest INSIDE match as a fallback). Box-ref to keep TS narrowing
    // through the nested-closure mutations.
    var best = {
        edge: null,
        inside: null,
    };
    var _loop_2 = function (item) {
        if (item.data.type === 'coloredTiles' &&
            item.data.id !== excludeId &&
            !item.data.isInvisible) {
            var target_2 = item.data;
            // PREVENT MERGE (Edge-to-Edge) - But allow INSIDE detection for overlap checks
            var canMerge = !((movingMode === 'outline' && (target_2.generationMode === 'random' || target_2.generationMode === 'manual' || target_2.generationMode === 'outline')) ||
                (movingMode === 'random' && target_2.generationMode === 'outline') ||
                (movingMode === 'random' && target_2.generationMode === 'manual'));
            // Scale-aware bounds (E5: floor at 0.01 to avoid div-by-zero / NaN).
            var targetScale = Math.max(0.01, (_b = target_2.scale) !== null && _b !== void 0 ? _b : 1);
            var targetCellSize_1 = cellSize * targetScale;
            var targetWidth_1 = target_2.columns * targetCellSize_1;
            var targetHeight_1 = target_2.rows * targetCellSize_1;
            var targetLeft_1 = target_2.center.x - targetWidth_1 / 2;
            var targetTop_1 = target_2.center.y - targetHeight_1 / 2;
            var targetRight_1 = targetLeft_1 + targetWidth_1;
            var targetBottom_1 = targetTop_1 + targetHeight_1;
            // B5: snap "feel" tracks the smaller of the two tiles in the interaction.
            var effectiveThreshold = snapThreshold * Math.min(draggedScale, targetScale);
            var skipManual1x1Hole_1 = function (offset) {
                return movingMode === 'manual' && target_2.generationMode === 'manual' &&
                    dragSize.width === cellSize && dragSize.height === cellSize &&
                    targetWidth_1 === targetCellSize_1 && targetHeight_1 === targetCellSize_1 && offset !== 0;
            };
            var tryEdge = function (dist, dir, offset) {
                if (skipManual1x1Hole_1(offset))
                    return;
                if (!best.edge || dist < best.edge.dist) {
                    best.edge = { result: { item: item, dir: dir, offset: offset }, dist: dist };
                }
            };
            // ── CELL-AWARE BRANCH (manual mode, sparse partColors) ─────────────────────
            // Manual tiles can be visually L-shaped inside their bounding rectangle.
            // The bounding-box edge logic below would snap to the rectangle's outer
            // edges, which doesn't match what users see. For manual mode with at
            // least one filled cell and a single-cell dragged tile, expose each
            // FILLED cell's empty neighbours as snap candidates instead.
            var partColorsMap_2 = target_2.partColors;
            var isCellFilled_1 = function (r, c) {
                if (r < 0 || r >= target_2.rows || c < 0 || c >= target_2.columns)
                    return false;
                var v = partColorsMap_2 === null || partColorsMap_2 === void 0 ? void 0 : partColorsMap_2["".concat(r, "-").concat(c)];
                return !!v && v !== 'transparent';
            };
            var hasFilledCells = !!partColorsMap_2 &&
                Object.values(partColorsMap_2).some(function (v) { return !!v && v !== 'transparent'; });
            var isSingleCellDrag = Math.abs(dragSize.width - targetCellSize_1) < 1 &&
                Math.abs(dragSize.height - targetCellSize_1) < 1;
            var isManualCellAware = target_2.generationMode === 'manual' && canMerge && hasFilledCells && isSingleCellDrag;
            var cellAwareHandled = false;
            if (isManualCellAware) {
                var dragCx_1 = dragLeft + dragSize.width / 2;
                var dragCy_1 = dragTop + dragSize.height / 2;
                // If the cursor sits inside a filled cell, fall through to the
                // bounding-box INSIDE check so the caller's "occupied → abort" path
                // can still fire. Don't generate cell-aware candidates here.
                var inFilled = (function () {
                    if (dragCx_1 < targetLeft_1 || dragCx_1 > targetRight_1)
                        return false;
                    if (dragCy_1 < targetTop_1 || dragCy_1 > targetBottom_1)
                        return false;
                    var dropR = Math.floor((dragCy_1 - targetTop_1) / targetCellSize_1);
                    var dropC = Math.floor((dragCx_1 - targetLeft_1) / targetCellSize_1);
                    return isCellFilled_1(dropR, dropC);
                })();
                if (!inFilled) {
                    var sides = [
                        { dr: -1, dc: 0, out: 'TOP' },
                        { dr: 1, dc: 0, out: 'BOTTOM' },
                        { dr: 0, dc: -1, out: 'LEFT' },
                        { dr: 0, dc: 1, out: 'RIGHT' },
                    ];
                    for (var r = 0; r < target_2.rows; r++) {
                        for (var c = 0; c < target_2.columns; c++) {
                            if (!isCellFilled_1(r, c))
                                continue;
                            for (var _c = 0, sides_2 = sides; _c < sides_2.length; _c++) {
                                var _d = sides_2[_c], dr = _d.dr, dc = _d.dc, out = _d.out;
                                var nr = r + dr;
                                var nc = c + dc;
                                if (isCellFilled_1(nr, nc))
                                    continue;
                                var cellCx = targetLeft_1 + (nc + 0.5) * targetCellSize_1;
                                var cellCy = targetTop_1 + (nr + 0.5) * targetCellSize_1;
                                var dx = Math.max(0, Math.abs(dragCx_1 - cellCx) - targetCellSize_1 / 2);
                                var dy = Math.max(0, Math.abs(dragCy_1 - cellCy) - targetCellSize_1 / 2);
                                var dist = Math.hypot(dx, dy);
                                if (dist > effectiveThreshold)
                                    continue;
                                var inBounds = nr >= 0 && nr < target_2.rows && nc >= 0 && nc < target_2.columns;
                                if (inBounds) {
                                    if (!best.inside || dist < best.inside.dist) {
                                        best.inside = { result: { item: item, dir: 'INSIDE', row: nr, col: nc }, dist: dist };
                                    }
                                }
                                else {
                                    var offset = out === 'TOP' || out === 'BOTTOM' ? nc : nr;
                                    if (!best.edge || dist < best.edge.dist) {
                                        best.edge = { result: { item: item, dir: out, offset: offset }, dist: dist };
                                    }
                                }
                            }
                        }
                    }
                }
                // For manual cell-aware: skip the bounding-box edge logic entirely.
                // Bounding-box INSIDE still runs below so occupied-cell drops get
                // detected and the caller can abort.
                cellAwareHandled = true;
            }
            if (!cellAwareHandled && canMerge) {
                // Horizontal adjacency (LEFT/RIGHT merge — vertical-axis offset).
                if (target_2.generationMode !== 'outline' && dragBottom >= targetTop_1 - effectiveThreshold && dragTop <= targetBottom_1 + effectiveThreshold) {
                    var offsetY = Math.round((dragTop - targetTop_1) / targetCellSize_1);
                    var dL = Math.abs(dragRight - targetLeft_1);
                    if (dL < effectiveThreshold)
                        tryEdge(dL, 'LEFT', offsetY);
                    var dR = Math.abs(dragLeft - targetRight_1);
                    if (dR < effectiveThreshold)
                        tryEdge(dR, 'RIGHT', offsetY);
                }
                // Vertical adjacency (TOP/BOTTOM merge — horizontal-axis offset).
                if (target_2.generationMode !== 'outline' && dragRight >= targetLeft_1 - effectiveThreshold && dragLeft <= targetRight_1 + effectiveThreshold) {
                    var offsetX = Math.round((dragLeft - targetLeft_1) / targetCellSize_1);
                    var dT = Math.abs(dragBottom - targetTop_1);
                    if (dT < effectiveThreshold)
                        tryEdge(dT, 'TOP', offsetX);
                    var dB = Math.abs(dragTop - targetBottom_1);
                    if (dB < effectiveThreshold)
                        tryEdge(dB, 'BOTTOM', offsetX);
                }
            }
            // INSIDE detection (must run even when canMerge is false so overlaps are caught).
            if (dragLeft >= targetLeft_1 - effectiveThreshold &&
                dragRight <= targetRight_1 + effectiveThreshold &&
                dragTop >= targetTop_1 - effectiveThreshold &&
                dragBottom <= targetBottom_1 + effectiveThreshold) {
                var r = Math.round((dragTop - targetTop_1) / targetCellSize_1);
                var c = Math.round((dragLeft - targetLeft_1) / targetCellSize_1);
                if (r >= 0 && r < target_2.rows && c >= 0 && c < target_2.columns) {
                    var dragCx = dragLeft + dragSize.width / 2;
                    var dragCy = dragTop + dragSize.height / 2;
                    var dist = Math.hypot(dragCx - target_2.center.x, dragCy - target_2.center.y);
                    if (!best.inside || dist < best.inside.dist) {
                        best.inside = { result: { item: item, dir: 'INSIDE', row: r, col: c }, dist: dist };
                    }
                }
            }
        }
    };
    for (var _i = 0, allManipulatives_3 = allManipulatives; _i < allManipulatives_3.length; _i++) {
        var item = allManipulatives_3[_i];
        _loop_2(item);
    }
    if (best.edge !== null)
        return best.edge.result;
    if (best.inside !== null)
        return best.inside.result;
    return null;
};
export var trimRandomEmptyEdgeRowsAndCols = function (ct, cellSize) {
    var _b, _c, _d, _e, _f;
    if (ct.generationMode !== 'random')
        return ct;
    var totalRows = Math.max(1, Math.ceil(ct.rows));
    var totalCols = Math.max(1, Math.ceil(ct.columns));
    var partColors = (_b = ct.partColors) !== null && _b !== void 0 ? _b : {};
    // In Random mode, a cell is "empty" only when explicitly marked transparent.
    // Missing entries are treated as filled (default 1x1 colored blocks).
    var minR = totalRows;
    var maxR = -1;
    var minC = totalCols;
    var maxC = -1;
    for (var r = 0; r < totalRows; r++) {
        for (var c = 0; c < totalCols; c++) {
            var key = "".concat(r, "-").concat(c);
            var v = partColors[key];
            if (v !== 'transparent') {
                if (r < minR)
                    minR = r;
                if (r > maxR)
                    maxR = r;
                if (c < minC)
                    minC = c;
                if (c > maxC)
                    maxC = c;
            }
        }
    }
    // If everything is empty (all explicit transparent), keep a minimal 1x1 empty grid.
    if (maxR === -1 || maxC === -1) {
        return __assign(__assign({}, ct), { rows: 1, columns: 1, partColors: { '0-0': 'transparent' }, dimensions: { width: cellSize, height: cellSize }, selectedPartKeys: [], cutRows: [], cutColumns: [], topLinearSegments: [], leftLinearSegments: [], openCuts: { rows: [], cols: [] } });
    }
    // No trimming needed
    if (minR === 0 && maxR === totalRows - 1 && minC === 0 && maxC === totalCols - 1) {
        return ct;
    }
    var newRows = maxR - minR + 1;
    var newCols = maxC - minC + 1;
    var newPartColors = {};
    for (var r = minR; r <= maxR; r++) {
        for (var c = minC; c <= maxC; c++) {
            var oldKey = "".concat(r, "-").concat(c);
            var newKey = "".concat(r - minR, "-").concat(c - minC);
            newPartColors[newKey] = partColors[oldKey] || TILE_COLORS[(r * 2 + c) % 4];
        }
    }
    var shiftY = (minR + maxR - (totalRows - 1)) * (cellSize / 2);
    var shiftX = (minC + maxC - (totalCols - 1)) * (cellSize / 2);
    var newCutRows = ((_c = ct.cutRows) !== null && _c !== void 0 ? _c : []).map(function (v) { return v - minR; }).filter(function (v) { return v > 0 && v < newRows; });
    var newCutCols = ((_d = ct.cutColumns) !== null && _d !== void 0 ? _d : []).map(function (v) { return v - minC; }).filter(function (v) { return v > 0 && v < newCols; });
    var newTopLinearSegments = ((_e = ct.topLinearSegments) !== null && _e !== void 0 ? _e : [])
        .map(function (v) { return v - minC; })
        .filter(function (v) { return v >= 0 && v < newCols; });
    var newLeftLinearSegments = ((_f = ct.leftLinearSegments) !== null && _f !== void 0 ? _f : [])
        .map(function (v) { return v - minR; })
        .filter(function (v) { return v >= 0 && v < newRows; });
    return __assign(__assign({}, ct), { rows: newRows, columns: newCols, center: {
            x: ct.center.x + shiftX,
            y: ct.center.y + shiftY,
        }, partColors: newPartColors, dimensions: {
            width: newCols * cellSize,
            height: newRows * cellSize,
        }, selectedPartKeys: [], cutRows: newCutRows, cutColumns: newCutCols, topLinearSegments: newTopLinearSegments, leftLinearSegments: newLeftLinearSegments });
};
export var trimManualEmptyEdgeRowsAndCols = function (ct, cellSize) {
    var _b, _c, _d, _e, _f;
    if (ct.generationMode === 'outline')
        return ct;
    if (ct.generationMode !== 'manual')
        return ct;
    var totalRows = Math.max(1, Math.ceil(ct.rows));
    var totalCols = Math.max(1, Math.ceil(ct.columns));
    var partColors = (_b = ct.partColors) !== null && _b !== void 0 ? _b : {};
    // In Manual mode, a cell is "filled" only when it has an explicit color entry.
    var minR = totalRows;
    var maxR = -1;
    var minC = totalCols;
    var maxC = -1;
    for (var r = 0; r < totalRows; r++) {
        for (var c = 0; c < totalCols; c++) {
            var v = partColors["".concat(r, "-").concat(c)];
            if (v) {
                if (r < minR)
                    minR = r;
                if (r > maxR)
                    maxR = r;
                if (c < minC)
                    minC = c;
                if (c > maxC)
                    maxC = c;
            }
        }
    }
    // If everything is empty, keep a minimal 1x1 empty grid.
    if (maxR === -1 || maxC === -1) {
        return __assign(__assign({}, ct), { rows: 1, columns: 1, partColors: {}, dimensions: { width: cellSize, height: cellSize }, selectedPartKeys: [], cutRows: [], cutColumns: [], topLinearSegments: [], leftLinearSegments: [] });
    }
    // No trimming needed
    if (minR === 0 && maxR === totalRows - 1 && minC === 0 && maxC === totalCols - 1) {
        return ct;
    }
    var newRows = maxR - minR + 1;
    var newCols = maxC - minC + 1;
    var newPartColors = {};
    for (var r = minR; r <= maxR; r++) {
        for (var c = minC; c <= maxC; c++) {
            var v = partColors["".concat(r, "-").concat(c)];
            if (v) {
                newPartColors["".concat(r - minR, "-").concat(c - minC)] = v;
            }
        }
    }
    // Adjust center so visible content stays in place
    var shiftY = (minR + maxR - (totalRows - 1)) * (cellSize / 2);
    var shiftX = (minC + maxC - (totalCols - 1)) * (cellSize / 2);
    var newCutRows = ((_c = ct.cutRows) !== null && _c !== void 0 ? _c : []).map(function (v) { return v - minR; }).filter(function (v) { return v > 0 && v < newRows; });
    var newCutCols = ((_d = ct.cutColumns) !== null && _d !== void 0 ? _d : []).map(function (v) { return v - minC; }).filter(function (v) { return v > 0 && v < newCols; });
    var newTopLinearSegments = ((_e = ct.topLinearSegments) !== null && _e !== void 0 ? _e : [])
        .map(function (v) { return v - minC; })
        .filter(function (v) { return v >= 0 && v < newCols; });
    var newLeftLinearSegments = ((_f = ct.leftLinearSegments) !== null && _f !== void 0 ? _f : [])
        .map(function (v) { return v - minR; })
        .filter(function (v) { return v >= 0 && v < newRows; });
    return __assign(__assign({}, ct), { rows: newRows, columns: newCols, center: {
            x: ct.center.x + shiftX,
            y: ct.center.y + shiftY,
        }, partColors: newPartColors, dimensions: {
            width: newCols * cellSize,
            height: newRows * cellSize,
        }, selectedPartKeys: [], cutRows: newCutRows, cutColumns: newCutCols, topLinearSegments: newTopLinearSegments, leftLinearSegments: newLeftLinearSegments });
};
// Compact entirely-empty rows/cols that sit between the just-appended merge col/row
// and the source's nearest filled cell on that side. This is the post-merge cleanup
// for the cell-extract → drop-adjacent-far-side bug, where the just-extracted slot
// would otherwise survive as an "invisible cell" in the middle of the merged result.
//
// IMPORTANT: this only prunes empties IMMEDIATELY between the appended slot and the
// nearest filled slot in the merge direction — it preserves intentional interior
// gaps elsewhere in the tile (e.g. a manual design with a deliberate hole).
//
// `mergeDir` tells the helper which side the new col/row was appended on:
//   - 'RIGHT' / 'BOTTOM': appended at the LAST index → walk inward from there.
//   - 'LEFT'  / 'TOP':    appended at the FIRST index → walk inward from there.
//   - 'INSIDE' / undefined: no-op (the merge replaced an existing cell, no append).
//
// Manual mode only — random's default colors mean "empty col" detection isn't
// reliable, and outline doesn't carry partColors.
export var compactEmptyInteriorRowsAndCols = function (ct, cellSize, mergeDir) {
    var _b;
    if (ct.generationMode !== 'manual')
        return ct;
    if (!mergeDir || mergeDir === 'INSIDE')
        return ct;
    var totalRows = Math.max(1, Math.ceil(ct.rows));
    var totalCols = Math.max(1, Math.ceil(ct.columns));
    var partColors = (_b = ct.partColors) !== null && _b !== void 0 ? _b : {};
    // Manual: a cell is "filled" only when it has an explicit color entry.
    var isCellFilled = function (r, c) { return !!partColors["".concat(r, "-").concat(c)]; };
    var colHasFilled = [];
    for (var c = 0; c < totalCols; c++) {
        var any = false;
        for (var r = 0; r < totalRows; r++) {
            if (isCellFilled(r, c)) {
                any = true;
                break;
            }
        }
        colHasFilled.push(any);
    }
    var rowHasFilled = [];
    for (var r = 0; r < totalRows; r++) {
        var any = false;
        for (var c = 0; c < totalCols; c++) {
            if (isCellFilled(r, c)) {
                any = true;
                break;
            }
        }
        rowHasFilled.push(any);
    }
    // Walk inward from the appended edge and collect empties until we hit a filled slot.
    var skipCols = new Set();
    var skipRows = new Set();
    if (mergeDir === 'RIGHT') {
        for (var c = totalCols - 2; c >= 0; c--) {
            if (colHasFilled[c])
                break;
            skipCols.add(c);
        }
    }
    else if (mergeDir === 'LEFT') {
        for (var c = 1; c < totalCols; c++) {
            if (colHasFilled[c])
                break;
            skipCols.add(c);
        }
    }
    else if (mergeDir === 'BOTTOM') {
        for (var r = totalRows - 2; r >= 0; r--) {
            if (rowHasFilled[r])
                break;
            skipRows.add(r);
        }
    }
    else if (mergeDir === 'TOP') {
        for (var r = 1; r < totalRows; r++) {
            if (rowHasFilled[r])
                break;
            skipRows.add(r);
        }
    }
    if (skipCols.size === 0 && skipRows.size === 0)
        return ct;
    var keepCols = [];
    for (var c = 0; c < totalCols; c++)
        if (!skipCols.has(c))
            keepCols.push(c);
    var keepRows = [];
    for (var r = 0; r < totalRows; r++)
        if (!skipRows.has(r))
            keepRows.push(r);
    if (keepCols.length === 0 || keepRows.length === 0)
        return ct;
    // Remap partColors with new indices.
    var newPartColors = {};
    keepRows.forEach(function (origR, newR) {
        keepCols.forEach(function (origC, newC) {
            var v = partColors["".concat(origR, "-").concat(origC)];
            if (v)
                newPartColors["".concat(newR, "-").concat(newC)] = v;
        });
    });
    // Centroid-preserving center shift: kept cells stay near their original world positions.
    var oldCenterColIdx = (totalCols - 1) / 2;
    var oldCenterRowIdx = (totalRows - 1) / 2;
    var avgKeptColIdx = keepCols.reduce(function (s, c) { return s + c; }, 0) / keepCols.length;
    var avgKeptRowIdx = keepRows.reduce(function (s, r) { return s + r; }, 0) / keepRows.length;
    var shiftX = (avgKeptColIdx - oldCenterColIdx) * cellSize;
    var shiftY = (avgKeptRowIdx - oldCenterRowIdx) * cellSize;
    var colIndexMap = new Map(keepCols.map(function (origC, newC) { return [origC, newC]; }));
    var rowIndexMap = new Map(keepRows.map(function (origR, newR) { return [origR, newR]; }));
    var remap = function (arr, m) {
        return (arr !== null && arr !== void 0 ? arr : [])
            .map(function (v) { return m.get(v); })
            .filter(function (v) { return v !== undefined; });
    };
    return __assign(__assign({}, ct), { rows: keepRows.length, columns: keepCols.length, center: {
            x: ct.center.x + shiftX,
            y: ct.center.y + shiftY,
        }, partColors: newPartColors, dimensions: {
            width: keepCols.length * cellSize,
            height: keepRows.length * cellSize,
        }, selectedPartKeys: [], cutRows: remap(ct.cutRows, rowIndexMap).filter(function (v) { return v > 0 && v < keepRows.length; }), cutColumns: remap(ct.cutColumns, colIndexMap).filter(function (v) { return v > 0 && v < keepCols.length; }), topLinearSegments: remap(ct.topLinearSegments, colIndexMap), leftLinearSegments: remap(ct.leftLinearSegments, rowIndexMap) });
};
export var isProperRectangle = function (_b) {
    var _c = _b.rows, rows = _c === void 0 ? 0 : _c, _d = _b.columns, columns = _d === void 0 ? 0 : _d, _e = _b.partColors, partColors = _e === void 0 ? {} : _e, generationMode = _b.generationMode;
    if (generationMode === 'outline')
        return true;
    for (var r = 0; r < rows; r++) {
        for (var c = 0; c < columns; c++) {
            var color = partColors["".concat(r, "-").concat(c)];
            if (generationMode === 'random') {
                if (color === 'transparent')
                    return false;
            }
            else {
                if (!color || color === 'transparent')
                    return false;
            }
        }
    }
    return true;
};
export var hasOutlineOneByOneBlock = function (tileData) {
    var _b;
    var totalRows = Math.ceil(tileData.rows);
    var totalCols = Math.ceil(tileData.columns);
    for (var r = 0; r < totalRows; r++) {
        for (var c = 0; c < totalCols; c++) {
            if ((_b = tileData.partColors) === null || _b === void 0 ? void 0 : _b["".concat(r, "-").concat(c)]) {
                return true;
            }
        }
    }
    return false;
};
